import { useState, useEffect } from "react";
import React from "react";
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import { toast } from "react-toastify";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { tokenDecode } from "../../utils/helper";
import { config } from "../../utils/config";
import { Paginated } from "../../components/Paginated";
import '../../components/table.css';
import styles from "../transaction/transaction.module.css"
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import moment from "moment"
import * as XLSX from 'xlsx';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import "./unsettledTransaction.css"
import MoreVertIcon from '@mui/icons-material/MoreVert';
//import { toast } from "react-toastify";
const { apiEndpoint } = config;

var $ = require('jquery');
const badgeMaker: any = {
    "Created": (order_state: any) => <span className="badge badge-primary">{order_state}</span>,
    "Shipped": (order_state: any) => <span className="badge badge-warning">{order_state}</span>,
    "Delivered": (order_state: any) => <span className="badge badge-success">{order_state}</span>,
    "Canceled": (order_state: any) => <span className="badge badge-danger">{order_state}</span>,
}


const Mstyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "40%",
    maxHeight: "500px",
    overflowY: "auto" as "auto",
    scrollbarWidth: "none",
    bgcolor: 'background.paper',
    border: '1px solid #E5E7EB',
    borderRadius: '20px',
    // boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 8px 10px -6px rgba(0, 0, 0, 0.04)',
    p: 4,
    '@media (max-width: 600px)': {
        width: '90%',
    },
};

const Unsettledtransction = () => {

    const decoded: any = tokenDecode();
    const [transactionList, setTransactionList]: any = useState([]);
    const [stransactionList, setStransactionList]: any = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDetailsLoading, setIsDetailsLoading] = useState(false);
    const [Fopen, setFOpen] = useState(false);
    const [Feopen, setFeOpen] = useState(false);
    const [open, setOpen] = useState(false);
    const [Msgopen, setMsgOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleFOpen = () => setFOpen(true);
    const handleFeOpen = () => setFeOpen(true);
    const handleFClose = () => setFOpen(false);
    const handleFeClose = () => setFeOpen(false);
    // console.log("dfghjkl56789", decoded?.data?.user[0]?.seller_id)
    const adminseller = decoded?.data?.user[0]?.seller_id
    const checkadmin = decoded?.data?.user[0]?.parent_id
    const isAdmin = (Array.isArray(decoded?.data?.user) ? decoded?.data?.user?.[0]?.seller_id : decoded?.data?.user?.seller_id) == 1;
    const sconditionvalue = Number(decoded?.data?.user[0].parent_id)
    console.log("dfghj4567567", sconditionvalue)

    const handleClose = async () => {
        setOpen(false); setCalculation({
            "order_id": "",
            "sellerapp_commission": "",
            "ondc_commission": "",
            "buyer_commission": "",
            "seller_amount": "",
            "order_total": "",
            "tds_deduction": "",
            "tcs_deduction": "",
            "receive_status": 0,
            "settlement_status": "",
            "buyer_commission_percentage": "",
            "gst_on_buyer_commission": "",
            "ONDC_Commissions": "",
            "seller_np_amount": "",
            "seller_np_amount_gst": ""

        })
        settdsValue(0);
        settcsValue(0);
        setsettleClicked(false);
        setTransactionid("");
        setTransactionidDate("");
        setalltransactions([]);
        allTransactionlist();

        getFilteredData()
    };
    const [calculation, setCalculation] = useState({
        "order_id": "",
        "sellerapp_commission": "",
        "ondc_commission": "",
        "buyer_commission": "",
        "seller_amount": "",
        "order_total": "",
        "tds_deduction": "",
        "tcs_deduction": "",
        "receive_status": 0,
        "settlement_status": "",
        "buyer_commission_percentage": "",
        "gst_on_buyer_commission": "",
        "ONDC_Commissions": "",
        "seller_np_amount": "",
        "seller_np_amount_gst": ""
    })
    const { data } = decoded;
    const rawData = {
        seller_id: ''
    }
    const [searchData, setSearchData]: any = useState(rawData);
    const { permission: { category, order, product, role, seller, tax, user } } = data;
    const [sellerList, setSellerList] = useState([]);
    const [valueid, setValueid] = useState("");
    const [valueamount, setValueamount] = useState("");
    const [valuedate, setValuedate] = useState("");
    const [alltransactionData, setalltransactionData] = useState([]);
    const [SelectionParam, setSelectionParam]: any = useState(false);
    const [selectedBox, setselectedBox]: any = useState([]);
    const [Transactionid, setTransactionid]: any = useState("")
    const [TransactionidDate, setTransactionidDate]: any = useState("")
    const [tdsValue, settdsValue] = useState(0);
    const [tcsValue, settcsValue] = useState(0);
    const [alltransactions, setalltransactions] = useState([])
    const [settleClicked, setsettleClicked] = useState(false);
    const [isSettling, setIsSettling] = useState(false);
    const [filterDaata, setfilterDaata] = useState({
        seller_id: "",
        startDate: "",
        endDate: ""
    })
    var count = 1;
    interface State extends SnackbarOrigin {
        sopen: boolean;
    }


    useEffect(() => {
        // console.log(selectedBox)
        if (selectedBox.length > 0) {
            handleClick({ vertical: 'top', horizontal: 'center' })
        }
    }, [selectedBox])
    function filterChangeHandler(e: any) {
        setfilterDaata((prev) => {
            return {
                ...prev, [e.target.name]: e.target.value
            }
        })
    }

    const [isExporting, setIsExporting] = useState(false);
    async function exportTransactionHandler(status = 0) {
        try {
            setIsExporting(true);
            const response = await axios({
                url: `${apiEndpoint}/snp/transactions/export-transaction`,
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${sessionStorage.getItem('token')}`,
                    "Content-Type": "application/json"
                },
                data: { status },
                responseType: "blob"
            });

            // Check if response is actually a JSON error message
            if (response.data instanceof Blob) {
                const text = await response.data.text();
                try {
                    const parsed = JSON.parse(text);
                    if (parsed?.status === false || parsed?.message) {
                        toast.error(parsed.message || "No transactions found for the selected filters!");
                        return;
                    }
                } catch (_) {
                    // Valid binary Excel file, proceed to download
                }
            } else if (typeof response.data === "string") {
                try {
                    const parsed = JSON.parse(response.data);
                    if (parsed?.status === false || parsed?.message) {
                        toast.error(parsed.message || "No transactions found for the selected filters!");
                        return;
                    }
                } catch (_) { }
            } else if (response.data && typeof response.data === "object") {
                if (response.data.status === false || response.data.message) {
                    toast.error(response.data.message || "No transactions found for the selected filters!");
                    return;
                }
            }

            const contentType = response.headers?.["content-type"] || "";
            const blob = new Blob([response.data], {
                type: contentType || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", `Unsettled transactions_${new Date().getTime()}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(downloadUrl);
            toast.success("Exported Successfully!", {
                position: "top-right",
                autoClose: 2000,
            });
        } catch (error: any) {
            let errorMsg = "Something Went Wrong while exporting!";
            try {
                if (error?.response?.data instanceof Blob) {
                    const errText = await error.response.data.text();
                    const errJson = JSON.parse(errText);
                    errorMsg = errJson?.message || errJson?.error || errText || errorMsg;
                } else if (error?.response?.data?.message) {
                    errorMsg = error.response.data.message;
                } else if (error?.response?.data?.error) {
                    errorMsg = error.response.data.error;
                } else if (error?.message) {
                    errorMsg = error.message;
                }
            } catch (_) { }
            toast.error(errorMsg);
        } finally {
            setIsExporting(false);
        }
    }

    const allTransactionlist = async () => {
        try {
            setIsLoading(true);
            const { data } = await axios({
                url: `${apiEndpoint}/snp/transactions/unsettled-transaction/0`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                }
            });
            if (data && data.status === true && Array.isArray(data.transaction)) {
                setalltransactions(data.transaction);
                setTransactionList(data.transaction);
                setStransactionList(data.transaction);
                setalltransactionData(data.transaction);
            }
        } catch (error) {
            console.log("error", error);
        } finally {
            setIsLoading(false);
        }
    }
    const fetchSellerList = async () => {

        try {
            const { data } = await axios({
                url: `${apiEndpoint}/transactionStatus`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: {
                    settlement_status: 0
                }
            });
            // console.log("transaction data -> ", data);
            if (data.status === 200) {
                setIsLoading(false);
                setTransactionList(data.data);
                setalltransactionData(data.data)

            }
        } catch (error) {
            console.log("error", error);

        }
    }
    const getTransaction = async (order_id: any) => {
        try {
            setIsDetailsLoading(true)
            setCalculation({ ...calculation, order_id });
            const { data } = await axios({
                url: `${apiEndpoint}/snp/transactions/get-calculation`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: {
                    order_id
                }
            });


            if (data && (data.status === true || data.status === 200) && data.data && data.data.length > 0) {
                setCalculation({
                    order_id,
                    "sellerapp_commission": parseFloat(data.data[0].sellerapp_commission || 0).toFixed(2),
                    "ondc_commission": parseFloat(data.data[0].ondc_commission || 0).toFixed(2),
                    "buyer_commission": parseFloat(data.data[0].buyer_commission || 0).toFixed(2),
                    "seller_amount": parseFloat(data.data[0].seller_amount || 0).toFixed(2),
                    "order_total": parseInt(data.data[0].order_total || 0).toFixed(2),
                    "tds_deduction": parseInt(data.data[0].tcs_deduction || 0).toFixed(2),
                    "tcs_deduction": parseInt(data.data[0].tds_deduction || 0).toFixed(2),
                    "receive_status": data.data[0].receive_status,
                    "settlement_status": data.data[0].settlement_status,
                    "buyer_commission_percentage": data.data[0].buyer_commission_percentage,
                    "gst_on_buyer_commission": data.data[0].gst_on_buyer_commission,
                    "ONDC_Commissions": data.data[0].ONDC_Commissions,
                    "seller_np_amount": data.data[0].seller_np_amount,
                    "seller_np_amount_gst": data.data[0].seller_np_amount_gst
                });

                settcsValue(parseInt(data.data[0].tcs_deduction || 0))
                settdsValue(parseInt(data.data[0].tds_deduction || 0))
            } else {
                toast.error(data?.message || "Order calculation not found!");
            }
            setIsDetailsLoading(false)
        } catch (error: any) {
            const apiErrorMessage = error?.response?.data?.message || error?.message || "Something Went Wrong!";
            toast.error(apiErrorMessage);
            setIsDetailsLoading(false)
        }
    }
    const getSellerList = async () => {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/getsellerlist`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                }
            });
            if (data.status === 200) {
                // console.log(data.data)
                setSellerList(data.data);
            }
        } catch (error) {
            console.log("error", error);
        }
    }
    const inputHandler = async (e: any) => {
        setValueid("");
        setValueamount("");
        setValuedate("");
        var optionvalue = e.target.value;
        if (optionvalue) {
            try {

                const {
                    seller_id
                } = searchData;
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filtertransactiondataall`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data: {
                        seller_id: optionvalue
                    }

                });
                if (data.status === 200) {
                    // console.log(data.response);
                    setTransactionList(data.response);
                    setStransactionList(data.response);
                }


            } catch (error) {
                console.log("error", error);
            }
        }
        else {
            setTransactionList(stransactionList);
        }
    };

    const inputeHandler = async (e: any) => {

        const optionvalue = e.target.value;
        setValueid(optionvalue);
        if (optionvalue) {
            try {
                const {
                    seller_id
                } = searchData;
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filtertransactionsellerdata`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data: {
                        seller_id: { searchData },
                        order_id: optionvalue
                    }

                });

                if (data.status === 200) {
                    // console.log(data);
                    setTransactionList(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            inputHandler(e);
        }
    };


    async function getFilteredData() {

        try {
            const { data } = await axios({
                url: `${apiEndpoint}/filtertransactiondata`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: {
                    ...filterDaata
                }

            });
            if (data.status === 200) {
                // console.log(data.response);
                setTransactionList(data.response);
                setStransactionList(data.response);
                setalltransactionData(data.response);
            }

            handleFClose()


        } catch (error) {
            handleFClose()
            console.log("error", error);
        }

    }


    function checkHandler(row: any) {
        // console.log("row---->", row)
        // console.log("dhadha", row.order_id);
        let hasId = selectedBox.some((item: any) => item == row.order_id)
        if (!hasId) {
            setselectedBox((prev: any) => {
                return [...prev, row.order_id]
            })
        } else {
            setselectedBox((prev: any) => {
                return prev.filter((item: any) => item !== row.order_id)
            })
        }

    }

    async function submitCheckedDatatoOn() {

        try {
            const { data } = await axios({
                url: `${apiEndpoint}/update_settlement`,
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                method: "POST",
                data: {
                    order_id: [...selectedBox],
                    transaction_id: Transactionid,
                    settlement_status: 1,
                    settlement_date: TransactionidDate
                },
            })

            if (data.status == 200) {

                if (data.status === 200) {
                    toast.success("Settled Successfully!", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    clearSelectionHandler()
                }
            } else {
                toast.error("Error in Setteling!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (err) {
            toast.error("Something Went Wrong!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        }

    }

    async function submitCheckedDataSingle() {
        try {
            setIsSettling(true);
            const { data } = await axios({
                url: `${apiEndpoint}/snp/transactions/settlementbyorder`,
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                method: "POST",
                data: {
                    order_id: calculation?.order_id,
                    settlement_status: 1,
                    seller_utr: Transactionid,
                    seller_settled_date: TransactionidDate
                },
            })

            if (data.status === true || data.status === 200) {
                toast.success(data.message || "Settled Successfully!", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                handleClose();
                setOpen(false);
            } else {
                toast.error(data.message || "Error in Setteling!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (err: any) {
            const errMsg = err?.response?.data?.message || "Something Went Wrong!";
            toast.error(errMsg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } finally {
            setIsSettling(false);
        }
    }

    async function ChangeHandler(e: React.ChangeEvent<HTMLSelectElement>) {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/transactionStatus`,
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                method: "POST",
                data: {
                    "settlement_status": e.target.value === "1" ? 1 : null
                }
            })

            if (data.status == 200) {
                setTransactionList(data.data)

            } else {

            }
        } catch (err) {
            toast.error("Something Went Wrong!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        }
    }

    const COLUMNS = [
        !SelectionParam ? {
            Header: "Serial No.",
            Footer: "Serial No.",
            accessor: (row: any, count: any) => {
                return <>{count + 1}</>
            },
            disableFilters: true,
            sticky: "left"
        } : {
            Header: "Select",
            Footer: "Select",
            accessor: (row: any) => {
                return <input type="checkbox" onChange={() => checkHandler(row)} checked={selectedBox.includes(row.order_id)} />

            },
            disableFilters: true,
            sticky: "left",

        },
        {
            Header: "Order Id",
            Footer: "Order Id",
            accessor: (a: any) => <span style={{ fontWeight: "700", color: "#0F172A" }}>{a?.order_id}</span>,
            sticky: "left"
        },
        {
            Header: "Seller Name",
            Footer: "Seller Name",
            accessor: "company_name",
            sticky: "left"
        },
        {
            Header: "Total Amount (in Rs)",
            Footer: "Total Amount (in Rs)",
            accessor: (a: any) => <span style={{ fontWeight: "700", color: "#0F172A" }}>₹{parseFloat(a?.order_total || 0).toFixed(0)}</span>,
            sticky: "left"
        },
        {
            Header: "Buyer Commission (in Rs)",
            Footer: "Buyer Commission (in Rs)",
            accessor: (a: any) => { let val = parseFloat(a?.buyer_amt || a?.buyer_amount || 0); return isNaN(val) ? 0 : Math.round(val * 1000) / 1000; },
            sticky: "left"
        },
        {
            id: "settlestatus",
            Header: "Settle Status",
            Footer: "Settle Status",
            accessor: (a: any) => {
                const isSettled = (a?.settlement_status === "0" || a?.settlement_status === 1 || a?.status === 1);
                return (
                    <span style={{
                        backgroundColor: isSettled ? "#DCFCE7" : "#FEF3C7",
                        color: isSettled ? "#15803D" : "#B45309",
                        padding: "5px 14px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: 600,
                        display: "inline-block"
                    }}>
                        {isSettled ? "Settled" : "Not Settled"}
                    </span>
                );
            },
            sticky: "left"
        },
        {
            Header: "Created At",
            Footer: "Created At",
            accessor: (a: any) => a?.created_at ? moment(a.created_at).format("DD-MM-YYYY HH:mm") : "N/A",
            sticky: "left"
        },
        {
            Header: "Action",
            Footer: "Action",
            accessor: (row: any) => {
                return (
                    <button
                        style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "50%",
                            backgroundColor: "#3B82F6",
                            color: "#FFFFFF",
                            border: "none",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            boxShadow: "0 2px 6px rgba(59, 130, 246, 0.3)",
                            transition: "all 0.2s ease"
                        }}
                        onClick={() => { getTransaction(row.order_id); handleOpen() }}
                        title="View Details"
                    >
                        <i className="fas fa-eye" style={{ fontSize: "14px" }}></i>
                    </button>
                );
            },
            sticky: "left"
        },

    ];
    count++

    useEffect(() => {
        // getSellerList();
        allTransactionlist();
    }, [])

    async function getallunsettledtransactions() {
        setIsLoading(true)
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/get_transactions_list_unsettled`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: {
                    settlement_status: 0
                }
            });
            // console.log("transaction data -> ", data);
            if (data.status === 200) {
                setTransactionList(data?.data);
                setStransactionList(data?.data);
                setalltransactionData(data?.data);
                setIsLoading(false)
            }
        } catch (error) {
            console.log("error", error);
            setIsLoading(false)

        }
    }



    async function OrderidSearchHandler(e: any) {
        try {
            const val = e.target.value ? e.target.value.trim() : "";
            if (val === "") {
                allTransactionlist();
            } else {
                setIsLoading(true);
                const { data } = await axios({
                    url: `${apiEndpoint}/snp/transactions/filter-transaction-order-id`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data: {
                        order_id: val,
                        status: 0
                        // seller_id: filterDaata.seller_id || ""
                    }
                });

                if (data && (data.status === 200 || data.status === true)) {
                    let resultList = data.transaction || data.response || data.data || [];
                    if (!Array.isArray(resultList)) {
                        resultList = [resultList];
                    }
                    setTransactionList(resultList);
                } else {
                    setTransactionList([]);
                }
            }
        } catch (error) {
            console.log("Search API error:", error);
            setTransactionList([]);
        } finally {
            setIsLoading(false);
        }
    }
    function inactiveProductHandler() {
        // console.log(productList)
        let z = transactionList.filter((item: any) => item)
        // console.log(z);
        let m = z.map((item: any) => item?.order_id)
        setselectedBox(m)
        // checkHandler(...m)
    }

    const [state, setState] = useState<State>({
        sopen: false,
        vertical: 'top',
        horizontal: 'center',
    });

    const { vertical, horizontal, sopen } = state;
    const handleClick = (newState: SnackbarOrigin) => {

        setState({ ...newState, sopen: true });
    };
    const handlesClose = () => {
        setState({ ...state, sopen: false });
    };


    async function clearSelectionHandler() {
        setSelectionParam(false)
        setselectedBox([])
        handlesClose()

    }

    function getCurrentDate() {
        const today = new Date();
        const year = today.getFullYear();
        let month: string | number = today.getMonth() + 1;
        let day: string | number = today.getDate();

        // Add leading zero if month or day is a single digit
        month = month < 10 ? `0${month}` : month;
        day = day < 10 ? `0${day}` : day;

        return `${year}-${month}-${day}`;
    }

    const action = (
        <div className="d-flex justify-content-between align-items-center" style={{ gap: "10px", padding: "20px" }} >

            <input type="text" className="form-control" placeholder="Transaction ID.." onChange={(e) => { setTransactionid(e.target.value) }} />

            <input type="date" name="" id="" className="form-control bg-white" max={getCurrentDate()} onChange={(e) => { setTransactionidDate(e.target.value) }} />

            <button className=" ml-5 w-50 text-center text-dark mb-1  p-1 " style={{ color: "white", background: "lightgrey", borderRadius: "20px", height: "30px", cursor: "pointer", fontWeight: "700", border: "none" }} disabled={((Transactionid === "") || (TransactionidDate === "")) ? true : false}
                onClick={submitCheckedDatatoOn}
            >
                Settle
            </button>
            <IconButton size="small" aria-label="close" color="inherit" onClick={clearSelectionHandler} style={{ marginLeft: "20px" }}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </div>
    );

    const preventMinus = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    };

    const [buyerUtr, setBuyerUtr] = useState("");
    const [buyerSettledDate, setBuyerSettledDate] = useState("");
    const [isReceiving, setIsReceiving] = useState(false);

    async function receiveHandler() {
        try {
            setIsReceiving(true);
            const { data } = await axios({
                url: `${apiEndpoint}/snp/transactions/receive_payment`,
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                method: "POST",
                data: {
                    order_id: calculation?.order_id,
                    tds: tdsValue,
                    tcs: tcsValue,
                    receive_status: 1,
                    buyer_utr: buyerUtr,
                    buyer_settled_date: buyerSettledDate
                },
            })

            if (data.status) {
                toast.success(data.message || "Received Successfully!", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setBuyerUtr("");
                // setBuyerSettledDate("");
                clearSelectionHandler();
                setOpen(false);
            } else {
                toast.error(data.message || "Error in Receiving!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (err: any) {
            const errMsg = err?.response?.data?.message || "Something Went Wrong!";
            toast.error(errMsg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } finally {
            setIsReceiving(false);
        }
    }

    const exportToExcel = (orders: any) => {

        const headers = [
            'S.No', "Order Id", "Seller Name", "Order Total", "Seller Amount", "Buyer Commission", "Settlement", "TDS", "TCS", "Settled Date", "Order Date"
        ];

        const data = orders.map((order: any, index: any) => {

            let orderCreatedDate = moment(order?.created_at).format("DD-MM-YYYY hh:mm:ss")
            let sellerName = order?.address?.start?.location?.descriptor?.name
            let sellerEmail = order?.address?.end?.contact?.email
            let sellerContact = order?.address?.end?.contact?.phone
            return {
                'S.No': index + 1,
                "Order Id": order?.order_id,
                "Seller Name": order.company_name,
                "Order Total": order?.order_total,
                "Seller Amount": order?.seller_amount,
                "Buyer Commission": order?.buyer_commission,
                "Buyer Commission Percentage": order?.buyer_commission_percentage,
                "Settlement": order?.settlement,
                "TDS": order?.tds,
                "TCS": order?.tcs,
                "Settled Date": order?.settled_date,
                "Order Date": order?.order_date
            }
        });

        // // Create a new workbook and worksheet
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(data, { header: headers });

        // // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Orders');

        // // Generate a unique name for the Excel file (you can customize this as needed)
        const fileName = `transactions_${new Date().getTime()}.xlsx`;

        // // Export the workbook as an Excel file
        XLSX.writeFile(wb, fileName);
    };

    const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
        props,
        ref,
    ) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleMsgClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setMsgOpen(false);
    };

    const handleBuyerUtrChange = (e: any) => {
        const value = e.target.value;
        if (/\s/.test(value)) {
            toast.error("Spaces are not allowed!", {
                position: "top-right",
                autoClose: 2000,
            });
            setBuyerUtr(value.replace(/\s/g, ""));
        } else {
            setBuyerUtr(value);
        }
    };

    const handleSellerUtrChange = (e: any) => {
        const value = e.target.value;
        if (/\s/.test(value)) {
            toast.error("Spaces are not allowed!", {
                position: "top-right",
                autoClose: 2000,
            });
            setTransactionid(value.replace(/\s/g, ""));
        } else {
            setTransactionid(value);
        }
    };

    async function selectSellerHandler(e: any) {
        setfilterDaata((prev) => {
            return { ...prev, seller_id: e.target.value }
        })
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/filtertransactiondata`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: {
                    seller_id: e.target.value
                }

            });
            if (data.status === 200) {
                // console.log(data.response);
                setTransactionList(data.response);
                setStransactionList(data.response);
                setalltransactionData(data.response);
            }

            handleFClose()


        } catch (error) {
            handleFClose()
            console.log("error", error);
        }
    }

    function calculateGST(originalValue: any, gstRate: number) {
        let z = parseInt(originalValue)
        return (z * gstRate) / 100;
    }


    const [file, setFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);

    const handleFileChange = (event: any) => {
        const selected = event.target.files?.[0];
        if (selected) {
            setFile(selected);
        }
    };

    const uploadFile = async () => {
        if (!file) {
            toast.error("Please select a file first!");
            return;
        }

        try {
            setIsUploading(true);
            const formData = new FormData();
            formData.append("file", file);

            const { data } = await axios({
                url: `${apiEndpoint}/snp/transactions/upload-csv`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    // Content-Type mat lagao, axios FormData ke liye khud
                    // multipart/form-data; boundary=... set kar dega
                },
                data: formData
            });

            if (data?.success === true || data?.status === true || data?.status === 200) {
                toast.success(data?.message || "File uploaded successfully!", {
                    position: "top-right",
                    autoClose: 2000,
                });
                setFile(null);
                handleFeClose();
                allTransactionlist(); // list refresh karne ke liye
            } else {
                toast.error(data?.message || "Upload failed!");
            }
        } catch (error: any) {
            const apiErrorMessage = error?.response?.data?.message || "Something Went Wrong while uploading!";
            toast.error(apiErrorMessage);
        } finally {
            setIsUploading(false);
        }
    };

    // const uploadFile = async () => {
    //     if (!file) {
    //         alert("Please select a file first!");
    //         return;
    //     }

    //     try {

    //         const formData: any = new FormData();
    //         formData.append("file", file);
    //         console.log(formData);

    //         let { data } = await axios({
    //             url: `${apiEndpoint}/unsettled_to_setteled`,
    //             method: 'POST',
    //             headers: {
    //                 "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`,
    //                 "Content-Type": "multipart/form-data"
    //             },
    //             data: formData


    //         })

    //         if (data?.success == "true") {
    //             toast.success("File uploaded successful..")
    //         }

    //     } catch (error) {
    //         console.error("Error:", error);
    //         alert("Upload failed!");
    //     }
    // };

    return (
        <>
            <ThemeMaker>
                <div className="row w-100 m-0 mt-1">
                    <div className="col-md-12 ">
                        <div className="card shadow-sm border border-light p-3" style={{ borderRadius: "20px", borderColor: "#E5E7EB", backgroundColor: "#ffffff", boxShadow: "0 10px 30px rgba(15, 23, 42, 0.04)", position: "sticky", top: "10px", zIndex: 30 }}>
                            <div className="py-2">
                                <div className={`d-flex justify-content-between p-2 align-items-center flex-wrap ${styles.headerContainer}`} style={{ gap: "15px" }}>
                                    <h4 className="font-weight-bold m-0" style={{ color: "#0F172A", fontSize: "24px" }}>
                                        Unsettled Transactions
                                    </h4>

                                    <div className="d-flex align-items-center flex-wrap" style={{ gap: "15px" }}>
                                        {(decoded?.data?.user?.seller_id <= 1 && decoded?.data?.user?.parent_id <= 1) ? (
                                            <fieldset style={{ border: "1.5px solid #F97316", borderRadius: "10px", padding: "0 12px 6px 12px", margin: 0, height: "46px", backgroundColor: "#FFFFFF" }}>
                                                <legend style={{ width: "auto", padding: "0 6px", fontSize: "11px", color: "#F97316", fontWeight: 600, margin: 0 }}>
                                                    Select Seller
                                                </legend>
                                                <select
                                                    name="seller_id"
                                                    onChange={(e) => { selectSellerHandler(e) }}
                                                    className="border-0 bg-transparent text-dark"
                                                    style={{ outline: "none", fontSize: "14px", cursor: "pointer", marginTop: "-6px" }}
                                                    value={filterDaata.seller_id}
                                                >
                                                    <option value="" disabled>Select seller...</option>
                                                    {sellerList.map((item: any) => (
                                                        <option value={item?.seller_id} key={item?.seller_id}>{item?.company_name}</option>
                                                    ))}
                                                </select>
                                            </fieldset>
                                        ) : null}

                                        <fieldset style={{ border: "1.5px solid #F97316", borderRadius: "10px", padding: "0 12px 6px 12px", margin: 0, height: "46px", backgroundColor: "#FFFFFF" }}>
                                            <legend style={{ width: "auto", padding: "0 6px", fontSize: "11px", color: "#F97316", fontWeight: 600, margin: 0 }}>
                                                Search Order ID
                                            </legend>
                                            <div className="d-flex align-items-center" style={{ marginTop: "-6px" }}>
                                                <i className="fas fa-search mr-2" style={{ fontSize: "13px", color: "#F97316" }}></i>
                                                <input
                                                    type="search"
                                                    name="order_id"
                                                    placeholder="Enter Order ID..."
                                                    className="border-0 bg-transparent text-dark"
                                                    style={{ outline: "none", fontSize: "14px", width: "170px" }}
                                                    onChange={(e: any) => OrderidSearchHandler(e)}
                                                />
                                            </div>
                                        </fieldset>

                                        {(decoded?.data?.user?.seller_id <= 1 && decoded?.data?.user?.parent_id <= 1) ? (
                                            <button className="btn btn-primary" style={{ backgroundColor: "#F97316", borderColor: "#F97316", borderRadius: "10px", height: "46px", padding: "0 20px", fontWeight: 600 }} onClick={handleFOpen}>
                                                Filters
                                            </button>
                                        ) : null}

                                        <button
                                            className="btn"
                                            style={{
                                                border: "1.5px solid #F97316",
                                                color: "#F97316",
                                                backgroundColor: "#FFFFFF",
                                                borderRadius: "10px",
                                                height: "46px",
                                                padding: "0 16px",
                                                fontWeight: 600,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "6px",
                                                boxShadow: "none"
                                            }}
                                            disabled={isExporting}
                                            onClick={() => exportTransactionHandler(0)}
                                        >
                                            <i className={`fas ${isExporting ? "fa-spinner fa-spin" : "fa-file-excel"}`} style={{ fontSize: "14px", color: "#F97316" }}></i>
                                            {isExporting ? "Exporting..." : "Export Transactions"}
                                        </button>

                                        {isAdmin || (checkadmin === "0") ? (
                                            <button
                                                className="btn btn-outline-secondary"
                                                style={{
                                                    borderColor: "#CBD5E1",
                                                    color: "#334155",
                                                    borderRadius: "10px",
                                                    height: "46px",
                                                    padding: "0 16px",
                                                    fontWeight: 600,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "6px",
                                                    backgroundColor: "#F8FAFC"
                                                }}
                                                onClick={handleFeOpen}
                                            >
                                                <i className="fas fa-file-upload" style={{ fontSize: "14px", color: "#F97316" }}></i>
                                                Upload CSV
                                            </button>
                                        ) : null}
                                    </div>
                                </div>
                            </div>

                            <div className="p-0">
                                <div className="table-responsive">

                                    {/* <div className="d-none d-md-flex justify-content-end mb-2">
                                        {SelectionParam ? <div className="d-flex align-items-center">
                                            <span onClick={clearSelectionHandler} className="text-center m-1 px-3 py-1" style={{ background: "#F3F4F6", color: "#374151", borderRadius: "8px", fontSize: "13px", cursor: "pointer", fontWeight: "600" }}>Cancel</span>
                                            <span onClick={inactiveProductHandler} className="text-center m-1 px-3 py-1" style={{ background: "#FFF7ED", color: "#F97316", border: "1px solid #F97316", borderRadius: "8px", fontSize: "13px", cursor: "pointer", fontWeight: "600" }}>Select All</span> </div> :
                                            <span onClick={() => setSelectionParam(true)} className="text-center d-block px-3 py-1" style={{ backgroundColor: "#F97316", color: "#FFFFFF", borderRadius: "8px", fontSize: "13px", cursor: "pointer", fontWeight: "600" }}>Edit</span>
                                        }
                                    </div> */}

                                    <div className="table-border overflow-hidden" style={{ borderRadius: "16px", border: "1px solid #E5E7EB" }}>

                                        {!isLoading ? <Paginated data={transactionList} columns={COLUMNS as any} /> : <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}><CircularProgress style={{ color: "#F97316" }} /></div>}
                                    </div>

                                    <div className={styles.transactionListing_mobile}>
                                        {transactionList.map((item: any) => {

                                            return <div className="border p-3 bg-white mt-2" style={{ borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.03)" }}>
                                                <div className="d-flex mt-1 align-items-center" style={{ gap: "10px" }}>
                                                    <span className="genericlabel" style={{ width: "28%" }} >Order ID</span>
                                                    <span className="font-weight-bold" style={{ fontSize: "14px", width: '70%', color: "#0F172A" }}>{item?.order_id}</span>
                                                </div>
                                                <div className="d-flex mt-1" style={{ gap: "10px" }}>
                                                    <span className="genericlabel" style={{ width: "28%" }} >Order Total</span>
                                                    <span className="" style={{ fontSize: "14px", width: '70%', color: "#F97316", fontWeight: "600" }}>₹{item?.order_total}</span>
                                                </div>
                                                <div className="d-flex mt-1" style={{ gap: "10px" }}>
                                                    <span className="genericlabel" style={{ width: "28%" }} > Seller Name</span>
                                                    <span className="" style={{ fontSize: "14px", width: '70%' }}>{item?.company_name}</span>
                                                </div>
                                                <div className="mt-2">
                                                    <p style={{ width: "90px", fontWeight: 600, borderRadius: "10px", color: "white", background: "#F97316", padding: "6px", textAlign: "center", cursor: "pointer", margin: 0 }}
                                                        onClick={() => { getTransaction(item.order_id); handleOpen() }} >View</p>

                                                </div>
                                            </div>

                                        })

                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={Mstyle}>
                        <div className="modal-header position-relative">
                            <p className="modal-title" style={{ fontSize: "14px", fontWeight: "500", color: "black" }}>Order id: {calculation?.order_id} </p>
                            <button type="button" className="close position-absolute" style={{ right: "0", top: "0" }} onClick={() => handleClose()}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        {/* <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <p>  Buyer Commission : {calculation?.buyer_commission} </p>
                                </div>
                                <div className="col-md-12">
                                    <p>  ONDC Commission :{calculation?.ondc_commission} </p>
                                </div>
                                <div className="col-md-12">
                                    <p>  Seller App Commission : {calculation?.sellerapp_commission} </p>
                                </div>
                                <div className="col-md-12">
                                    <p>  Seller Amount : {(calculation?.seller_amount)} </p>
                                </div>
                                <div className="col-md-12">
                                    <p>  Total Amount : {calculation?.order_total} </p>
                                </div>
                            </div>
                        </div> */}
                        {!isDetailsLoading ? <TableContainer component={Paper}>
                            <Table sx={{ maxWidth: "100%" }} aria-label="simple table">
                                <TableHead>

                                    <TableRow >
                                        <TableCell align="center" className="bg-light">Order Amount</TableCell>

                                        <TableCell align="center" className="bg-light font-weight-bold" >
                                            <span>&#8377;</span>  {calculation?.order_total}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>

                                        <TableCell align="center" className="bg-light">TDS Deduction</TableCell>
                                        {/* <TableCell align="center" className="bg-light font-weight-bold">{calculation.tds_deduction}</TableCell> */}

                                        <TableCell align="center" className="bg-light font-weight-bold">
                                            <span>&#8377;</span>  {tdsValue}
                                            {/* <input type="number" className="form-control" min={0} value={tdsValue} onKeyPress={preventMinus} onChange={(e: any) => settdsValue(e.target.value)} /> */}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align="center" className="bg-light">TCS Deduction</TableCell>
                                        {/* <TableCell align="center" className="bg-light font-weight-bold">{calculation.tcs_deduction}</TableCell> */}
                                        <TableCell align="center" className="bg-light font-weight-bold">
                                            <span>&#8377;</span>  {tcsValue}
                                            {/* <input type="number" className="form-control" min={0} value={tcsValue} onKeyPress={preventMinus} onChange={(e: any) => settcsValue(e.target.value)} /> */}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow> <TableCell align="center" className="bg-light">Buyer Commission ({calculation.buyer_commission_percentage}%)</TableCell>
                                        <TableCell align="center" className="bg-light font-weight-bold"> <span>&#8377;</span>  {calculation.buyer_commission}</TableCell>
                                    </TableRow>
                                    <TableRow> <TableCell align="center" className="bg-light">GST On Buyer Commission (18%)</TableCell>
                                        <TableCell align="center" className="bg-light font-weight-bold"> <span>&#8377;</span> {(Math.round(parseFloat(calculation.gst_on_buyer_commission) * 100) / 100).toFixed(2)} </TableCell>
                                        {/* <TableCell align="center" className="bg-light font-weight-bold"> <span>&#8377;</span> {calculation.gst_on_buyer_commission} </TableCell> */}
                                    </TableRow>
                                    <TableRow> <TableCell align="center" className="bg-light">Seller NP Commission ({calculation.ONDC_Commissions}%)</TableCell>
                                        <TableCell align="center" className="bg-light font-weight-bold"> <span>&#8377;</span>{(Math.round(parseFloat(calculation.seller_np_amount) * 100) / 100).toFixed(2)} </TableCell>
                                    </TableRow>
                                    <TableRow> <TableCell align="center" className="bg-light">GST on Seller NP amount</TableCell>
                                        <TableCell align="center" className="bg-light font-weight-bold"> <span>&#8377;</span> {(Math.round(parseFloat(calculation.seller_np_amount_gst) * 100) / 100).toFixed(2)}</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell align="center" className="bg-light">Seller Amount</TableCell>
                                        <TableCell align="center" className="bg-light font-weight-bold" > <span>&#8377;</span>  {calculation.seller_amount}</TableCell>
                                    </TableRow>





                                </TableHead>

                            </Table>

                            <div className="d-flex justify-content-end p-2 w-100" style={{ gap: "13px" }}>
                                {(calculation.receive_status !== 1 && sconditionvalue == 0) ? (
                                    <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Buyer UTR"
                                            value={buyerUtr}
                                            onChange={handleBuyerUtrChange}
                                        />
                                        <input
                                            type="date"
                                            className="form-control bg-white"
                                            max={getCurrentDate()}
                                            value={buyerSettledDate}
                                            onChange={(e) => setBuyerSettledDate(e.target.value)}
                                        />
                                        <button
                                            className="btn btn-primary p-2 px-3"
                                            disabled={buyerUtr === "" || buyerSettledDate === "" || isReceiving}
                                            onClick={receiveHandler}
                                        >
                                            {isReceiving ? "Receiving..." : "Receive"}
                                        </button>
                                    </div>
                                ) : null}

                                {(calculation.settlement_status !== "0" && calculation.receive_status == 1 && sconditionvalue == 0) ? (
                                    <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Seller UTR"
                                            value={Transactionid}
                                            onChange={handleSellerUtrChange}
                                        />
                                        <input
                                            type="date"
                                            className="form-control bg-white"
                                            min={buyerSettledDate}
                                            max={getCurrentDate()}
                                            value={TransactionidDate}
                                            onChange={(e) => setTransactionidDate(e.target.value)}
                                        />
                                        <button
                                            className="btn p-2 px-3" style={{ backgroundColor: isSettling ? "#d97706" : "#F97316", color: "white", borderRadius: "10px", border: "none" }}
                                            disabled={Transactionid === "" || TransactionidDate === "" || isSettling}
                                            onClick={submitCheckedDataSingle}
                                        >
                                            {isSettling ? "Settling..." : "Settle"}
                                        </button>
                                    </div>
                                ) : null}
                            </div>

                        </TableContainer> : null
                        }
                        {
                            isDetailsLoading ? <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}><CircularProgress /></div> : null
                        }
                    </Box>
                </Modal>

                <Modal open={Fopen}
                    onClose={handleFClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description">


                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content" style={{ minHeight: "200px" }}>
                            <div className="modal-header d-flex justify-content-between">

                                <h5 className="modal-title text-dark genericlabel" id="exampleModalLongTitle"> Filters  </h5>

                                <span aria-hidden="true" onClick={handleFClose} style={{ cursor: "pointer" }} ><CloseIcon /></span>

                            </div>


                            <div className="modal-body w-50" >


                                {(decoded?.data?.user?.seller_id === 1 || decoded?.data?.user?.parent_id === 1) ?
                                    <div > <div className={styles.selectionControl}>
                                        <select name="seller_id" id=""
                                            // onChange={(e: any) => inputHandler(e)}
                                            onChange={filterChangeHandler}
                                            className="form-control mb-3"
                                            value={filterDaata.seller_id}

                                        >
                                            <option value="">Select Seller</option>
                                            {
                                                sellerList.map((item: any) => (
                                                    <option value={item?.seller_id} key={item?.seller_id}>{item?.name}</option>
                                                ))
                                            }

                                        </select>
                                    </div>
                                    </div>
                                    : ""}

                                <div className="d-flex " style={{ gap: "20px" }}>

                                    <div>
                                        <label >Start Date</label>

                                        <input name="startDate" type="date" className="form-control" onChange={filterChangeHandler} value={filterDaata.startDate} max="{{ getCurrentDate() }}"
                                        />
                                    </div>

                                    <div>
                                        <label className="text-dark" >End Date</label>
                                        <input name="endDate" type="date" onChange={filterChangeHandler} className="form-control " value={filterDaata.endDate} max="{{ getCurrentDate() }}"
                                        />
                                    </div>

                                </div>

                            </div>

                            <div className="modal-header d-flex justify-content-end " style={{ gap: "20px" }}>

                                <button className="btn btn-danger" data-dismiss="modal" aria-label="Close" onClick={() => {
                                    window.location.reload()
                                    // handleFClose();
                                    // fetchSellerList();
                                    // setfilterDaata({
                                    //     seller_id: "",
                                    //     startDate: "",
                                    //     endDate: ""
                                    // })


                                }} >Clear Filter</button>

                                <button className="btn btn-primary" data-dismiss="modal" aria-label="Close"
                                    onClick={getFilteredData}
                                >Apply Filter</button>
                            </div>


                        </div>
                    </div>


                </Modal >

                <Modal open={Feopen}
                    onClose={handleFeClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description">


                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content" style={{ minHeight: "200px" }}>
                            <div className="modal-header d-flex justify-content-between">

                                <h5 className="modal-title genericlabel" id="exampleModalLongTitle"> Upload CSV  </h5>

                                <span aria-hidden="true" onClick={handleFeClose} style={{ cursor: "pointer" }} ><CloseIcon /></span>

                            </div>


                            <div className="modal-body " >
                                <input
                                    key={Feopen ? "open" : "closed"}
                                    type="file"
                                    className="form-control"
                                    onChange={handleFileChange}
                                />
                            </div>

                            <div className="modal-header d-flex justify-content-end " style={{ gap: "20px" }}>

                                <button
                                    className="btn btn-primary"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    disabled={!file || isUploading}
                                    onClick={uploadFile}
                                >
                                    {isUploading ? "Uploading..." : "Upload"}
                                </button>
                            </div>


                        </div>
                    </div>


                </Modal >
            </ThemeMaker >

            <div style={{ width: "25%" }}>
                {/* <Button onClick={handleClick}>Open simple snackbar</Button> */}
                <Snackbar
                    anchorOrigin={{ vertical, horizontal }}
                    open={sopen}
                    sx={{ width: "100%" }}
                    // onClose={handleClose}
                    key={vertical + horizontal}
                    action={action}
                />
            </div>

            <Snackbar open={Msgopen} autoHideDuration={20000} onClose={handleMsgClose} key={vertical + horizontal} anchorOrigin={{ vertical, horizontal }}>
                <Alert onClose={handleMsgClose} sx={{ width: '100%', padding: "30px", fontWeight: 600, background: "#105293", fontSize: "18px" }} >
                    To see transactions, Select a seller.
                </Alert>
            </Snackbar>
        </>
    )
}


export default Unsettledtransction;